export default [
  {
    altText: "Exclusive offers for 2023 with BigPay and AirAsia! ",
    bannerID: "bigpay-MY-20022023",
    desktopImage:"https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_D_Web-banner_MS.jpg",
    mobileImage:"https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_M_Web-banner_MS.jpg",
    tabletImage:"https://www.airasia.com/aa/bigpay/images/SA-x-BP-Intergration_D_Web-banner_MS.jpg",
  }
]
